import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCaptionStyleConfigured.meta';

export type UseTrackCaptionStyleConfiguredParams = {
  video_id: string;
  font: string;
  color: string;
  position: 'top' | 'center' | 'bottom';
  effect_type: string;
};

export const useTrackCaptionStyleConfigured = () => {
  const { track } = useAnalyticsUtilities();

  const trackCaptionStyleConfigured = useCallback(
    (params: UseTrackCaptionStyleConfiguredParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCaptionStyleConfigured };
};
